export default "__VITE_ASSET__Bsd2L_T7__"